import type { ReactNode } from 'react'

import type { Breadcrumb } from '@/types/shared'
import { Breadcrumbs } from '@/components/navigation/Breadcrumbs'

type PageHeaderProps = {
  title: string
  description?: string
  breadcrumbs?: Breadcrumb[]
  actions?: ReactNode
}

export function PageHeader({ title, description, breadcrumbs = [], actions }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap items-start justify-between gap-6">
        <div className="space-y-3">
          {breadcrumbs.length > 0 ? <Breadcrumbs items={breadcrumbs} /> : null}
          <div>
            <h1 className="text-3xl font-semibold tracking-tight text-white sm:text-4xl">{title}</h1>
            {description ? <p className="mt-2 max-w-2xl text-sm text-slate-300">{description}</p> : null}
          </div>
        </div>
        {actions ? <div className="flex items-center gap-3">{actions}</div> : null}
      </div>
    </div>
  )
}
